<template>
<div :id="tabid" class='song-list-container'>
    <!-- <header-charts v-if="layout == 'charts'" class="row m-h--5 m-b-0 m-t-8"></header-charts> -->
    
    <div class="row song-list m-h--5">
        <div class="col-xs-12">
            <div class="row">
                <song-widget v-if="i > Math.round(currentWidget/8)*8 - 10 && i < Math.round(currentWidget/8)*8 + 10" v-for="(song, i) in songs" :key="i" :song="song" :layout="layout" :class="songs.length == take ? 'no-transition' : ''" :origin="origin"></song-widget>
                <div v-else class="song-widget placeholder col-xs-6 p-h-5 no-transition">
                    <div class="inner-container"><loader size="128px"></loader></div>
                </div>
                
                <div v-if="loading && !fetchedAllSongs && !songs.length">
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                    <div class="song-widget placeholder col-xs-6 p-h-5 last last-loaded">
                        <div class="inner-container"><loader size="128px"></loader></div>
                    </div>
                </div>

                <div v-if="!fetchedAllSongs && songs.length" class="song-widget preloader col-xs-6 p-h-5">
                    <loader size="128px"></loader>
                </div>                                
            </div>
        </div>
    </div>

</div>
</template>

<script>

export default {
    components: {
        'header-charts': require('@/components/Song/Widget/HeaderTrending.vue').default,
        'song-widget': require('@/components/Song/Widget/Chart.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props: {
        tabid: { default: null },
        layout: { default: 'default' },
        origin: { default: '< not set >' },
        playlistName: { default: 'Charts' },
    },

    data() {
        return {
            songs: [],
            loading: true,
            scrollPosition: {
                left: 0,
            },            
            fetchedAllSongs: false,
            skip: 0,
            take: 10,
            currentWidget: 0
        }
    },

    activated(){
        var wW = $(`#${this.tabid} .song-list .song-widget`).width() + 10;

        $(`#${this.tabid} .song-list`).scrollLeft(this.scrollPosition.left);
        this.currentWidget = Math.round(this.scrollPosition.left / wW);
    },    

    mounted() {
        this.getSongs();

        var that = this;
        var scrollTimeout = false;
        var wW = $(`#${this.tabid} .song-list .song-widget`).width() + 10;

        //horizontal
        $(`#${this.tabid} .song-list`).on('touchstart', function() {
            $(this).stop(true, true);
        }).on('scroll', function() {
            that.scrollPosition.left = $(this)[0].scrollLeft;
            that.currentWidget = Math.round($(this)[0].scrollLeft / wW);

            if($(this).scrollLeft() + $(this).innerWidth() >= $(this)[0].scrollWidth) {
                if (that.fetchedAllSongs || that.loading) {
                    return;
                }

                $(this).animate({ scrollLeft: $(this)[0].scrollWidth }, 500);
                that.getSongs(true);
            }

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                $(this).stop(true, true).animate({ scrollLeft: that.currentWidget * wW }, 250);
            }, 250);
        });
    },

    methods: {
        getSongs(append = false) {
            this.loading = true;
            if (!append){
                $(`#${this.tabid} .song-list`).addClass('no-transitions');
                this.songs = [];
            }

            this.$http.get(this.getEndpoint).then((success) => {
                $(`#${this.tabid} .song-list`).removeClass('no-transition');

                $.each(success.data.data, (i, row) => {
                    var viral = row.viral;
                    
                    // assign default song structure
                    row.viral = false;
                    row.id = row.soundfeed_song_id;
                    row.uploader = {
                        id: row.uploader_id,
                        name: ''
                    }
                    row.genres = [];
                    row.video_provider_id = row.url.split('?')[1].replace("v=", "");

                    delete row.soundfeed_song_id;
                    delete row.uploader_id;

                    this.songs.push($.extend({}, row));

                    if (viral){
                        row.viral = true;
                        row.position = viral;

                        this.songs.push($.extend({}, row));
                    }                        
                });

                this.fetchedAllSongs = success.data.data.length < this.take;
                this.skip += this.take;
                this.loading = false;
            })
        },
    },

    computed: {
        getEndpoint() {
            return App.restApi + `/api/trending-charts?skip=${this.skip}&take=${this.take}`;
        },
    },
}
</script>